import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { MediaViewerService } from '../media-viewer/media-viewer.service';
import { MediaBankHelperService } from '../media-bank/media-bank-helper.service';
import { DetectDevicesService } from '../fi-shared-services';
import { FileType } from '../types';
import { IMediaBankFile } from '../media-bank';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { Subject } from 'rxjs';
import { IVideoProgressEvent } from '@fi-shared/media-bank/fi-vimeo/fi-vimeo-player-api';
import { FiMediaStorageService } from '@fi-shared/media-bank/fi-media-storage.service';

@Directive({
    selector: '[fiImagePreviewClick]',
    standalone: false,
})
export class ImagePreviewClickDirective {
    constructor(
        private elementRef: ElementRef,
        private mediaViewerService: MediaViewerService,
        private mediaBankHelper: MediaBankHelperService,
        private detectDevice: DetectDevicesService,
        private fiMediaStorageService: FiMediaStorageService,
    ) {}

    @Input('fiImagePreviewClick') mediaFile: IMediaBankFile;
    @Input('fiVideoPreviewListener$') videoProgressListener$: Subject<IVideoProgressEvent>;

    @HostListener('click', ['$event'])
    _onClick($event: MouseEvent) {
        const element: HTMLElement = this.elementRef.nativeElement;
        $event.stopPropagation();
        $event.preventDefault();

        if (element.matches('img')) {
            this.mediaViewerService.Show(
                this.elementRef.nativeElement.getAttribute('src'),
                [this.mediaFile],
                undefined,
            );
        } else if (element.matches('video')) {
            this.mediaViewerService.ShowVideoPopup(
                this.elementRef.nativeElement.querySelector('source').getAttribute('src'),
                this.mediaFile,
                undefined,
                this.videoProgressListener$,
            );
        } else if (element.matches('a')) {
            if (this.mediaFile.FileType == FileType.Image) {
                this.mediaViewerService.Show(
                    this.elementRef.nativeElement.querySelector('img').getAttribute('src'),
                    [this.mediaFile],
                    undefined,
                );
            } else if (this.detectDevice.isMobilePhone()) {
                this.mediaBankHelper.downloadMediaBankFile(this.mediaFile);
            } else {
                this.mediaBankHelper.downloadMediaBankFileRef(this.mediaFile, { openPdfInNewWindow: true });
            }
        }
    }
}
